export const dispatchLocalStorage = ({ key, value, callback }: any): void => {
  localStorage.setItem(key, value)
  if (callback) callback({ key, value })
  window.dispatchEvent(new Event('storage'))
}

export const removeLocalStorage = ({ key, callback }: any): void => {
  localStorage.removeItem(key)
  if (callback) callback({ key })
  window.dispatchEvent(new Event('storage'))
}
